"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeURL = void 0;
const getThemeURL = (res, partnername, type, configType) => {
    if (res && res[configType] && partnername) {
        return `/${partnername || ''}/${type}/${res[configType]}.json`;
    }
    return '';
};
exports.getThemeURL = getThemeURL;
